import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { MapPin, ArrowRight, Images } from "lucide-react";

const ProjectsSection = () => {
  const projects = [
    {
      title: "Backyard Landscape Project",
      location: "Beverly Hills, CA",
      image: "https://images.unsplash.com/photo-1762608675427-09ac2dbd1540?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBiYWNreWFyZCUyMHBhdGlvJTIwZGVzaWduJTIwcGF2aW5nJTIwbGFuZHNjYXBpbmd8ZW58MHx8fHwxNzcyNzA2MjUzfDA&ixlib=rb-4.1.0&q=85",
      category: "Landscaping",
    },
    {
      title: "Garden Maintenance Service",
      location: "Santa Monica, CA",
      image: "https://images.unsplash.com/photo-1759355787118-7b48305965d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxiZWF1dGlmdWwlMjBtYW5pY3VyZWQlMjBob21lJTIwZ2FyZGVuJTIwbGF3biUyMGxhbmRzY2FwaW5nfGVufDB8fHx8MTc3MjcwNjI1Mnww&ixlib=rb-4.1.0&q=85",
      category: "Maintenance",
    },
    {
      title: "Residential Lawn Installation",
      location: "Pasadena, CA",
      image: "https://images.unsplash.com/photo-1689728318937-17d24bc0a65c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBnYXJkZW5lciUyMHdvcmtpbmclMjBpbiUyMGdhcmRlbiUyMGxhd24lMjBtb3dlcnxlbnwwfHx8fDE3NzI3MDYyNTN8MA&ixlib=rb-4.1.0&q=85",
      category: "Installation",
    },
    {
      title: "Front Yard Renovation",
      location: "Malibu, CA",
      image: "https://images.unsplash.com/photo-1728706613021-e447801e1ea6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBnYXJkZW5lciUyMHdvcmtpbmclMjBpbiUyMGdhcmRlbiUyMGxhd24lMjBtb3dlcnxlbnwwfHx8fDE3NzI3MDYyNTN8MA&ixlib=rb-4.1.0&q=85",
      category: "Landscaping",
    },
  ];

  return (
    <section
      data-testid="projects-section"
      className="section-padding bg-[#F3F4F1] relative noise-texture"
    >
      <div className="container mx-auto max-w-7xl px-4 md:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
          <div>
            <span className="inline-flex items-center gap-2 text-[#C2410C] font-medium text-sm mb-4">
              <Images className="w-4 h-4" />
              Our Work
            </span>
            <h2
              data-testid="projects-headline"
              className="font-heading text-3xl md:text-4xl lg:text-5xl text-[#1A2C22] font-bold mb-4"
            >
              Recent Projects
            </h2>
            <p className="text-[#4B5563] text-base md:text-lg max-w-xl">
              Browse our portfolio of completed landscaping and gardening projects across Los Angeles.
            </p>
          </div>
          <Link to="/projects">
            <Button
              data-testid="view-all-projects"
              className="bg-[#2D5A27] hover:bg-[#1E3F1B] text-white h-12 px-8 rounded-full cta-primary"
            >
              View All Projects
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {projects.map((project, index) => (
            <div
              key={index}
              data-testid={`project-card-${index}`}
              className="project-card group cursor-pointer"
            >
              <div className="relative aspect-[4/5] overflow-hidden rounded-2xl">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover"
                />
                <div className="project-overlay flex flex-col justify-end p-6">
                  <span className="text-[#C2410C] text-xs font-medium mb-2">
                    {project.category}
                  </span>
                  <h3 className="text-white font-heading font-semibold text-lg mb-1">
                    {project.title}
                  </h3>
                  <div className="flex items-center gap-1 text-white/80 text-sm">
                    <MapPin className="w-3 h-3" />
                    {project.location}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
